export default "__VITE_ASSET__CLCkZXYU__"